/* Cool Drips — multi-tier bundle discount progress bar (25% off 3+, 50% off 5+) */
(function () {
  'use strict';
  if (window.__cdTiers) return;
  window.__cdTiers = true;

  var TIER1_QTY = 3;
  var TIER2_QTY = 5;

  var CSS = '' +
    '.cd-tiers{margin:10px 0 14px;padding:12px 14px;border:1px solid rgba(0,0,0,.08);border-radius:10px;background:#fff}' +
    '.cd-tiers__text{margin:0 0 24px;font-size:12.5px;font-weight:600;line-height:1.45}' +
    '.cd-tiers__text em{font-style:normal;background:linear-gradient(90deg,#fb33a6,#8e37ff 55%,#09c8f5);-webkit-background-clip:text;background-clip:text;color:transparent}' +
    '.cd-tiers__track{position:relative;height:7px;border-radius:99px;background:#ececf1;margin:0 6px}' +
    '.cd-tiers__fill{position:absolute;left:0;top:0;bottom:0;border-radius:99px;background:linear-gradient(90deg,#fb33a6,#8e37ff 55%,#09c8f5);transition:width .45s ease}' +
    '.cd-tiers__marker{position:absolute;top:50%;width:13px;height:13px;border-radius:50%;background:#fff;border:2px solid #d4d4dd;transform:translate(-50%,-50%);box-sizing:border-box}' +
    '.cd-tiers__marker.is-hit{border-color:#8e37ff;background:#8e37ff}' +
    '.cd-tiers__chip{position:absolute;bottom:calc(100% + 5px);left:50%;transform:translateX(-50%);font-size:10px;font-weight:700;letter-spacing:.02em;color:#6b6b76;white-space:nowrap}' +
    '.cd-tiers__marker--end .cd-tiers__chip{left:auto;right:-3px;transform:none}' +
    '.cd-tiers__marker.is-hit .cd-tiers__chip{color:#8e37ff}';

  function injectCss() {
    if (document.getElementById('cd-tiers-css')) return;
    var s = document.createElement('style');
    s.id = 'cd-tiers-css';
    s.textContent = CSS;
    document.head.appendChild(s);
  }

  function message(c) {
    var left;
    if (c >= TIER2_QTY) {
      return '🔥 <em>50% OFF</em> unlocked — maximum savings, applied automatically at checkout!';
    }
    if (c >= TIER1_QTY) {
      left = TIER2_QTY - c;
      return '🎉 <em>25% OFF</em> unlocked! Add ' + left + ' more item' + (left === 1 ? '' : 's') + ' for <em>50% OFF</em>';
    }
    if (c > 0) {
      left = TIER1_QTY - c;
      return 'Add ' + left + ' more item' + (left === 1 ? '' : 's') + ' to unlock <em>25% OFF</em> your whole order!';
    }
    return 'Mix &amp; match: <em>25% OFF</em> any ' + TIER1_QTY + ' items • <em>50% OFF</em> any ' + TIER2_QTY + ' — applied automatically';
  }

  function render(el, count) {
    el.setAttribute('count', count);
    var pct = Math.min((count / TIER2_QTY) * 100, 100);
    el.innerHTML =
      '<p class="cd-tiers__text">' + message(count) + '</p>' +
      '<div class="cd-tiers__track">' +
      '<div class="cd-tiers__fill" style="width:' + pct + '%"></div>' +
      '<span class="cd-tiers__marker' + (count >= TIER1_QTY ? ' is-hit' : '') + '" style="left:' + (TIER1_QTY / TIER2_QTY) * 100 + '%"><span class="cd-tiers__chip">3 items = 25%</span></span>' +
      '<span class="cd-tiers__marker cd-tiers__marker--end' + (count >= TIER2_QTY ? ' is-hit' : '') + '" style="left:100%"><span class="cd-tiers__chip">5 = 50%</span></span>' +
      '</div>';
  }

  var registry = new Set();
  var lastCount = null;

  var DiscountTierBar = /** @class */ (function () {
    function C() { return Reflect.construct(HTMLElement, [], C); }
    C.prototype = Object.create(HTMLElement.prototype);
    C.prototype.constructor = C;
    Object.setPrototypeOf(C, HTMLElement);
    C.prototype.connectedCallback = function () {
      injectCss();
      registry.add(this);
      var c = lastCount !== null ? lastCount : parseInt(this.getAttribute('count') || '0', 10) || 0;
      render(this, c);
    };
    C.prototype.disconnectedCallback = function () { registry.delete(this); };
    return C;
  })();

  if (!customElements.get('discount-tier-bar')) {
    customElements.define('discount-tier-bar', DiscountTierBar);
  }

  function update(count) {
    lastCount = count;
    registry.forEach(function (el) { render(el, count); });
  }

  var refreshTimer = null;
  function refresh() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      fetch('/cart.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.json(); })
        .then(function (c) {
          if (c && typeof c.item_count === 'number') update(c.item_count);
        })
        .catch(function () {});
    }, 200);
  }

  var origFetch = window.fetch;
  window.fetch = function () {
    var url = '';
    try {
      url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    } catch (e) { /* noop */ }
    var p = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      p.then(refresh).catch(function () {});
    }
    return p;
  };

  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (typeof url === 'string' && /\/cart\/(add|change|update|clear)/.test(url)) {
      this.addEventListener('loadend', refresh);
    }
    return origOpen.apply(this, arguments);
  };

  ['cart:updated', 'cart:refresh', 'cart:change'].forEach(function (ev) {
    document.addEventListener(ev, refresh);
  });

  try {
    var data = JSON.parse(document.getElementById('cart-data').textContent);
    if (data && typeof data.item_count === 'number') lastCount = data.item_count;
  } catch (e) { /* noop */ }
})();
